/* eslint-disable @typescript-eslint/no-dynamic-delete */
import { convertUnit } from './convertUnit';
import { ensureRegexp } from './ensureRegexp';
import { getConvertedVariable } from './getConvertedVariable';
/**
 * Retrieve the spectrum with only X/Y data that match all the selectors
 * If more than one variable match the selector the 'x' or 'y' variable will be
 * taken
 */
export function getXYSpectra(spectra = [], selector = {}) {
    const selectedSpectra = [];
    if (spectra.length < 1)
        return selectedSpectra;
    let { dataType, title, xUnits, yUnits, variables, xVariable = 'x', yVariable = 'y', units, labels, xLabel, yLabel, meta, index, } = selector;
    if (index !== undefined) {
        return [spectra[index]];
    }
    if (dataType) {
        dataType = ensureRegexp(dataType);
    }
    if (title) {
        title = ensureRegexp(title);
    }
    if (units && !xUnits && !yUnits)
        [yUnits, xUnits] = units.split(/\s*vs\s*/);
    if (labels && !xLabel && !yLabel) {
        [yLabel, xLabel] = labels.split(/\s*vs\s*/);
    }
    if (variables) {
        const parts = variables.split(/\s*vs\s*/);
        if (parts.length === 2) {
            xVariable = parts[1];
            yVariable = parts[0];
        }
    }
    if (xLabel)
        xLabel = ensureRegexp(xLabel);
    if (yLabel)
        yLabel = ensureRegexp(yLabel);
    for (let spectrum of spectra) {
        let variableNames = Object.keys(spectrum.variables);
        if (!(variableNames.length > 1))
            continue;
        // we filter on general spectrum information
        if (dataType) {
            if (!spectrum.dataType || !dataType.exec(spectrum.dataType)) {
                continue;
            }
        }
        if (title) {
            if (!spectrum.title || !title.exec(spectrum.title)) {
                continue;
            }
        }
        if (meta && typeof meta === 'object') {
            if (!spectrum.meta)
                continue;
            for (let key in spectrum.meta) {
                if (!spectrum.meta[key])
                    continue;
                let value = ensureRegexp(spectrum.meta[key]);
                if (!value.exec(spectrum.meta[key]))
                    continue;
            }
        }
        let x = getPossibleVariable(spectrum.variables, {
            units: xUnits,
            label: xLabel,
            variableName: xVariable,
        });
        let y = getPossibleVariable(spectrum.variables, {
            units: yUnits,
            label: yLabel,
            variableName: yVariable,
        });
        if (x && y) {
            selectedSpectra.push({
                title: spectrum.title,
                dataType: spectrum.dataType,
                meta: spectrum.meta,
                variables: { x, y },
                id: spectrum.id,
            });
        }
    }
    return selectedSpectra;
}
function getPossibleVariable(variables, selector = {}) {
    var _a, _b;
    const { units, label, variableName } = selector;
    let possible = { ...variables };
    let key;
    if (units !== undefined) {
        for (key in possible) {
            const variable = variables[key];
            let convertibleUnits = true;
            try {
                convertUnit(1, (variable === null || variable === void 0 ? void 0 : variable.units) || '', units);
            }
            catch (e) {
                convertibleUnits = false;
            }
            if (convertibleUnits && variable) {
                possible[key] = getConvertedVariable(variable, units);
            }
            else {
                delete possible[key];
            }
        }
    }
    if (label !== undefined) {
        const regexpLabel = ensureRegexp(label);
        for (key in possible) {
            if (!regexpLabel.exec((_b = (_a = variables[key]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '')) {
                delete possible[key];
            }
        }
    }
    if (variableName !== undefined) {
        if (possible[variableName])
            return possible[variableName];
        const upper = variableName.toUpperCase();
        if (Object.prototype.hasOwnProperty.call(possible, upper)) {
            return possible[upper];
        }
        const lower = variableName.toLowerCase();
        if (Object.prototype.hasOwnProperty.call(possible, lower)) {
            return possible[lower];
        }
    }
    const possibleFiltered = Object.values(possible).filter((val) => val !== undefined);
    if (possibleFiltered.length > 0) {
        return possibleFiltered[0];
    }
}
//# sourceMappingURL=data:application/json;base64,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